export function formatStudyLength(studyLength: number, singular?: boolean) {
  const weeks = Math.floor(studyLength / 7);
  const days = studyLength > 35 ? studyLength % 30 : studyLength % 7;
  const months = Math.floor(studyLength / 30);
  if (months && studyLength > 35) {
    return (
      months +
      ' month' +
      (months > 1 && !singular ? 's' : '') +
      (days ? ` ${days} day` + (days > 1 && !singular ? 's' : '') : '')
    );
  } else if (weeks) {
    return (
      weeks +
      ' week' +
      (weeks > 1 && !singular ? 's' : '') +
      (days ? ` ${days} day` + (days > 1 && !singular ? 's' : '') : '')
    );
  } else {
    return `${days} day` + (days > 1 && !singular ? 's' : '');
  }
}
